export default __webpack_public_path__ + "static/blog-img-b4fb8c131318949837f23529f518499a.png";